import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ngForSort',
  pure: true,
  standalone: false,
})
export class NgForSortPipe implements PipeTransform {
  transform<T>(items: ReadonlyArray<T>, sortFn: (itemA: T, itemB: T) => number): ReadonlyArray<T> {
    if (!items || !sortFn) {
      return items;
    }
    return [...items].sort(sortFn);
  }
}
